import type { ElementType } from 'react';

import { ComponentRequisitionStatusEnum } from '@/types/enums/component-requisition-status.enum';
import { t } from '@/utils/lang';
import Chip from '@mui/material/Chip';

interface StatusChipProps {
    status: ComponentRequisitionStatusEnum;
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipComponentRequisitionStatus = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color: 'info' | 'warning' | 'success' | 'error' | 'default';

    const lowerCaseStatus = status?.toLowerCase();

    switch (lowerCaseStatus) {
        case ComponentRequisitionStatusEnum.Created.toLowerCase():
            label = 'Mới';
            color = 'info';
            break;
        case ComponentRequisitionStatusEnum.Approved.toLowerCase():
            label = 'Xác nhận';
            color = 'success';
            break;
        case ComponentRequisitionStatusEnum.Rejected.toLowerCase():
            label = 'Đã hủy';
            color = 'error';
            break;
        default:
            label = t('Không xác định');
            color = 'default';
    }

    if (showChip) {
        return (
            <Component
                variant='tonal'
                label={t(label, 'ComponentRequisition')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'ComponentRequisition'),
        color,
    };
};

export default ChipComponentRequisitionStatus;
